import { checkAuth } from 'utils/auth'

import Dashboard from 'containers/Dashboard'
import Landing from 'containers/Landing'

import 'styles/App.scss'

const App = () => {
  const isLoggedIn = checkAuth()
  return (
    <div className='container center column'>
      { isLoggedIn ? <Dashboard /> : <Landing /> }
    </div>
  )
}

export default App
